import React from 'react';
import { expandFontTheme, theme } from '@contrast-security-inc/design-system-foundations';
import { css, cx } from '@emotion/css';
const guidanceStyles = css `
  display: flex;
  ${expandFontTheme(theme.font.metadata)};
  color: ${theme.color.neutral100};
  align-self: flex-start;
  flex-grow: 1;
  padding-left: 16px;
`;
const disabledColorStyles = css `
  color: ${theme.color.neutral60};
`;
export const Guidance = ({ guidance, testId, isDisabled, id }) => {
    if (!guidance) {
        return null;
    }
    return (React.createElement("div", { "data-testid": testId && `${testId}-guidance`, className: cx(guidanceStyles, isDisabled && disabledColorStyles), id: id && `${id}-guidance` }, guidance));
};
